import React, { useState } from "react";
import Layout from "../../../components/layouts/Layout";
import { useParams } from "react-router-dom";
import { useCustomerDetailsByAdmin } from "../../../hooks/admin/customers.admin";
import LoadingErrorState from "../../../components/ui/LoadingErrorState";
import CustomerHeader from "../../../components/admin/customers/CustomerHeader";
import CustomerTabs from "../../../components/admin/customers/CustomerTabs";
import CustomerBasicInfo from "../../../components/admin/customers/CustomerBasicInfo";

export default function CustomerDetailsPage() {
  const [activeTab, setActiveTab] = useState("basic");
  const { customerId } = useParams<{ customerId: string }>();
  const numericCustomerId = customerId ? parseInt(customerId) : 0;
  const { data: customer, isLoading, isError } =
    useCustomerDetailsByAdmin(numericCustomerId);

  const tabs = [
    { id: "basic", label: "tabs.basicInfo" },
    { id: "orders", label: "tabs.orders" },
    { id: "wallet", label: "tabs.wallet" },
    { id: "activity", label: "tabs.activity" },
    { id: "reports", label: "tabs.reports" },
  ];

  return (
    <Layout headline="" title="">
      <LoadingErrorState isError={isError} isLoading={isLoading} />
      {customer && (
        <div className="p-6 space-y-6 font-poppins text-Black">
          <CustomerHeader customer={customer} />
          <CustomerTabs
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />

          <div className="bg-white rounded-2xl shadow-custom-light p-6 min-h-[200px]">
            {activeTab === "basic" && <CustomerBasicInfo customer={customer} />}
            {activeTab !== "basic" && (
              <p className="text-muted">
                سيتم عرض بيانات{" "}
                {tabs.find((t) => t.id === activeTab)?.label} هنا...
              </p>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}
